import { API_BASE_URL } from "../config";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const safeJson = async (res) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

export async function fetchNotifications({ unreadOnly = false, limit = 50, offset = 0 } = {}) {
  const params = new URLSearchParams();
  if (unreadOnly) params.set("unread_only", "true");
  params.set("limit", limit);
  params.set("offset", offset);
  const res = await fetch(`${API_BASE_URL}/notifications?${params.toString()}`, {
    headers: authHeaders(),
  });
  const data = await safeJson(res);
  if (!res.ok || !data?.success) throw new Error(data?.message || "Failed to load notifications");
  return data.data || [];
}

export async function fetchUnreadCount() {
  const res = await fetch(`${API_BASE_URL}/notifications/unread-count`, {
    headers: authHeaders(),
  });
  const data = await safeJson(res);
  if (!res.ok || !data?.success) return 0;
  return data.unread_count || 0;
}

export async function markNotificationRead(id) {
  const res = await fetch(`${API_BASE_URL}/notifications/${id}/read`, {
    method: "POST",
    headers: authHeaders(),
  });
  return res.ok;
}

export async function markAllNotificationsRead() {
  const res = await fetch(`${API_BASE_URL}/notifications/mark-all-read`, {
    method: "POST",
    headers: authHeaders(),
  });
  const data = await safeJson(res);
  return data?.updated || 0;
}

export async function deleteNotification(id) {
  const res = await fetch(`${API_BASE_URL}/notifications/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return res.ok;
}

export async function saveFcmToken(token) {
  try {
    const res = await fetch(`${API_BASE_URL}/notifications/fcm-token`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ token }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
